import React from "react";
import {Row, Col} from "reactstrap";
import PropTypes from "prop-types";
import {FormattedDate} from "react-intl";
import { FormattedNumber } from "../../../FormattedNumber/FormattedNumber";

import {CustomFormInput} from "../../../../utils/FormFields";
import RecurringCommissionsAccounts from "./Accounts";

const RecurringCommissions = ({recurringCommission}) => {
  return (
    <React.Fragment>
      <Row>
        <Col xs={6} md={4} lg={3}>
          <CustomFormInput label="Type">
            {recurringCommission.RecurringCommissionType}
          </CustomFormInput>
        </Col>
        <Col xs={6} md={4} lg={3}>
          <CustomFormInput label="Range">
            <FormattedDate
              value={`${recurringCommission.RecurringCommissionFrom}T00:00`}
            />{" "}
            {" - "}
            <FormattedDate
              value={`${recurringCommission.RecurringCommissionTo}T00:00`}
            />
          </CustomFormInput>
        </Col>
        <Col xs={6} md={4} lg={3}>
          <CustomFormInput label="Execution">
            <FormattedDate
              value={`${recurringCommission.RecurringCommissionExecutionDate}T00:00`}
            />
          </CustomFormInput>
        </Col>
        <Col xs={6} md={4} lg={3}>
          <CustomFormInput label="Status">
            {recurringCommission.RecurringCommissionStatus}
          </CustomFormInput>
        </Col>
      </Row>
      <hr />
      <RecurringCommissionsAccounts accounts={recurringCommission.Accounts} />
    </React.Fragment>
  );
};

RecurringCommissions.propTypes = {
  recurringCommission: PropTypes.object.isRequired
};

export default RecurringCommissions;
